import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.licensing.cpanel.currentVariety;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'LICENSING_CPANEL_CURRENTVARIETY',
	method: 'POST',
	url: '/licensing/cpanel/currentVariety.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
